export const INTEGRATIONS_SET = 'INTEGRATIONS_SET'
export const INTEGRATIONS_DELETE_SUCCESS = 'INTEGRATIONS_DELETE_SUCCESS'
